<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">{{ headerText }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body pb-0">
    <p class="text-muted">{{ introText }}</p>

    <div class="alert alert-info" *ngIf="loadingSrvs">Loading...</div>

    <div class="alert alert-success" *ngIf="successMessage">{{ successMessage }}</div>
    <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>

    <table *ngIf="!loadingSrvs" class="table table-hover">
      <tbody>
        <tr (click)="setDefault(0)">
          <td class="cursor-pointer" style="border-top: none">
            {{ noDefaultLabel }}
            <span class="badge badge-primary ml-2" *ngIf="!currentDefaultViewId">
              Current
            </span>
          </td>
        </tr>
        <tr *ngFor="let srv of srvs" (click)="setDefault(srv.id)">
          <td class="cursor-pointer" style="line-height: 1.1">
            {{ srv.name }}
            <span class="badge badge-primary ml-2" *ngIf="currentDefaultViewId === srv.id">
              Current
            </span>
            <br>
            <small class="text-muted">
              Last edited by
              {{ getStaffNameDisplay(srv.last_updated_by_first_name, srv.last_updated_by_last_name, srv.last_updated_by_email) }}
              on
              {{ dateStringFromISO8601(srv.updated_at) }}
            </small>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="activeModal.close()">
      Close
    </button>
  </div>

</ng-container>
